export default __webpack_public_path__ + "static/media/placeholder_dummy2016-deko01-de-mobile.3230c1c7.png";